import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import { Controller } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

const RadioGroupInput = ({
  id,
  name,
  error,
  control,
  intlLabel,
  errorIntl,
  defaultValue,
  rules,
  className,
  children,
  fullWidth = true,
  ...props
}) => (
  <FormControl fullWidth={fullWidth} className={className} error={!!error}>
    <FormLabel htmlFor={id}>
      <FormattedMessage {...intlLabel} />
    </FormLabel>
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      error={error}
      render={({ field }) => (
        <RadioGroup id={id} {...props} {...field}>
          {children}
        </RadioGroup>
      )}
    />
    {error && (
      <FormHelperText>
        <FormattedMessage {...errorIntl} />
      </FormHelperText>
    )}
  </FormControl>
);

export default RadioGroupInput;
